export const extractUUID = (param: string | null): string => {
	if (!param) return '';
	// UUID v4 pattern: 8-4-4-4-12 hexadecimal characters
	const uuidPattern =
		/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
	const match = param.match(uuidPattern);
	return match ? match[0] : '';
};
